var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-button-group"},_vm._l((_vm.options),function(ref){
var optionValue = ref[0];
var optionLabel = ref[1];
return _c('RadioButton',{key:optionValue,attrs:{"targetValue":optionValue,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', optionValue)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v("\n    "+_vm._s(optionLabel)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }